import { Link } from '@inertiajs/react'
import type { TopicStats, TopicSummary } from '../../types'

export default function TopicsSummaryCard({ stats, teamId }: { stats: TopicStats; teamId: number }) {
  return (
    <div className="bg-white rounded-lg border border-[#351E1D]/10">
      <div className="flex items-center justify-between px-5 py-4 border-b border-[#351E1D]/10">
        <h3 className="font-bold uppercase tracking-widest text-text-secondary" style={{ fontSize: '16px' }}>Topics</h3>
        <Link href={`/teams/${teamId}/topics`} className="font-semibold text-text-primary hover:underline" style={{ fontSize: '14px' }}>
          View All
        </Link>
      </div>

      <div className="px-5 pt-4 pb-2 flex gap-4">
        <span className="text-text-secondary" style={{ fontSize: '16px' }}>{stats.open_count} active</span>
        {stats.resolved_this_week > 0 && (
          <span className="text-[#15532E]" style={{ fontSize: '16px' }}>{stats.resolved_this_week} resolved this week</span>
        )}
      </div>

      <div className="p-5 pt-2">
        {stats.top_topics.length > 0 ? (
          <div className="space-y-2.5">
            {stats.top_topics.map((t: TopicSummary) => (
              <div key={t.id} className="flex items-center gap-3">
                <span className="text-text-primary flex-1 truncate" style={{ fontSize: '16px' }}>{t.title}</span>
                {t.priority && (
                  <span className="px-1.5 py-0.5 rounded font-bold uppercase tracking-wider bg-[#ED1C24]/10 text-[#ED1C24] flex-shrink-0" style={{ fontSize: '10px' }}>
                    PRIORITY
                  </span>
                )}
                {t.votes_count > 0 && (
                  <span className="font-bold px-1.5 py-0.5 rounded bg-[rgba(237,28,36,0.15)] text-[#ED1C24] flex-shrink-0" style={{ fontSize: '12px' }}>
                    {t.votes_count}
                  </span>
                )}
                {t.owner && (
                  <div
                    className="w-6 h-6 rounded-full bg-[#351E1D]/20 text-text-primary font-bold flex items-center justify-center flex-shrink-0"
                    style={{ fontSize: '12px' }}
                    title={`${t.owner.first_name} ${t.owner.last_name}`}
                  >
                    {t.owner.initials}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-text-secondary text-center py-4" style={{ fontSize: '16px' }}>
            No open topics.{' '}
            <Link href={`/teams/${teamId}/topics`} className="text-text-primary hover:underline">
              Add a topic
            </Link>
          </p>
        )}
      </div>
    </div>
  )
}
